export default "__VITE_ASSET__2f71160a__"